export default "__VITE_ASSET__3Do1ZHRj__"